import L from 'leaflet';
import 'leaflet.markercluster';

class MapController {
	constructor(
		mapElementId = 'results-map',
		initialCoords = [49.2002211, 16.6078411],
		//initialCoords = [49.0516994, 14.4357936], // Hluboká nad Vltavou
		initialZoom = 10,
	) {
		this.mapElementId = mapElementId;
		this.mapElement = document.getElementById(mapElementId);

		if (!this.mapElement) {
			console.warn('map element not found');
			return;
		}

		this.initialCoords = initialCoords;
		this.initialZoom = initialZoom;
		this.map = this.initializeMap();
		this.initializeButton();
		this.initializeCustomButtons();
		this.userMarker = null;
		this.markersCluster = L.markerClusterGroup({
			iconCreateFunction: function (cluster) {
				return L.divIcon({
					html: cluster.getChildCount(),
					className: 'mycluster',
					iconSize: L.point(60, 60),
				});
			},
		});
		this.map.addLayer(this.markersCluster);
		this.pinIcon = L.icon({
			iconUrl: './assets/images/map-pin.png',
			iconSize: [56, 56], // size of the icon
			iconAnchor: [28, 56], // point of the icon which will correspond to marker's location
			popupAnchor: [0, 0], // point from which the popup should open relative to the iconAnchor
		});
		this.pinIconBlue = L.icon({
			iconUrl: './assets/images/map-pin-blue.png',
			iconSize: [38, 47], // size of the icon
			iconAnchor: [19, 47], // point of the icon which will correspond to marker's location
			popupAnchor: [0, 0], // point from which the popup should open relative to the iconAnchor
		});
	}

	initializeMap() {
		const map = L.map(this.mapElementId, {
			scrollWheelZoom: false,
			zoomControl: false,
		}).setView(this.initialCoords, this.initialZoom);

		L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
			scrollWheelZoom: false,
			attribution:
				'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
		}).addTo(map);

		this.showUserLocation();

		return map;
	}

	initializeCustomButtons() {
		const customButtons = L.control({ position: 'topright' });
		customButtons.onAdd = map => {
			let container = L.DomUtil.create('div', 'map-custom-control');

			// Tlačítko pro přiblížení
			const zoomInButton = L.DomUtil.create(
				'button',
				'zoom-in',
				container,
			);
			zoomInButton.innerHTML =
				'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">\n' +
				'  <mask id="mask0_1157_15322" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">\n' +
				'    <rect x="0.34668" y="0.204102" width="30.9807" height="30.9807" fill="#D9D9D9"/>\n' +
				'  </mask>\n' +
				'  <g mask="url(#mask0_1157_15322)">\n' +
				'    <path d="M14.5465 24.7303V16.9851H6.80127V14.4034H14.5465V6.6582H17.1282V14.4034H24.8734V16.9851H17.1282V24.7303H14.5465Z" fill="#1D34FE"/>\n' +
				'  </g>\n' +
				'</svg>';
			zoomInButton.onclick = () => {
				map.zoomIn();
			};

			// Tlačítko pro oddálení
			const zoomOutButton = L.DomUtil.create(
				'button',
				'zoom-out',
				container,
			);
			zoomOutButton.innerHTML =
				'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">\n' +
				'  <mask id="mask0_1157_15330" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">\n' +
				'    <rect x="0.34668" y="0.557617" width="30.9807" height="30.9807" fill="#D9D9D9"/>\n' +
				'  </mask>\n' +
				'  <g mask="url(#mask0_1157_15330)">\n' +
				'    <path d="M6.80127 17.3386V14.7568H24.8734V17.3386H6.80127Z" fill="#1D34FE"/>\n' +
				'  </g>\n' +
				'</svg>';
			zoomOutButton.onclick = () => {
				map.zoomOut();
			};

			const locationButton = L.DomUtil.create(
				'button',
				'get-location',
				container,
			);
			locationButton.innerHTML =
				'<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">\n' +
				'  <mask id="mask0_1157_15314" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="31">\n' +
				'    <rect x="0.34668" y="0.836914" width="30" height="30" fill="#D9D9D9"/>\n' +
				'  </mask>\n' +
				'  <g mask="url(#mask0_1157_15314)">\n' +
				'    <path d="M14.0967 29.5244V27.0244C11.4925 26.7327 9.25814 25.6546 7.39355 23.79C5.52897 21.9255 4.45085 19.6911 4.15918 17.0869H1.65918V14.5869H4.15918C4.45085 11.9827 5.52897 9.74837 7.39355 7.88379C9.25814 6.01921 11.4925 4.94108 14.0967 4.64941V2.14941H16.5967V4.64941C19.2008 4.94108 21.4352 6.01921 23.2998 7.88379C25.1644 9.74837 26.2425 11.9827 26.5342 14.5869H29.0342V17.0869H26.5342C26.2425 19.6911 25.1644 21.9255 23.2998 23.79C21.4352 25.6546 19.2008 26.7327 16.5967 27.0244V29.5244H14.0967ZM15.3467 24.5869C17.7633 24.5869 19.8258 23.7327 21.5342 22.0244C23.2425 20.3161 24.0967 18.2536 24.0967 15.8369C24.0967 13.4202 23.2425 11.3577 21.5342 9.64941C19.8258 7.94108 17.7633 7.08691 15.3467 7.08691C12.93 7.08691 10.8675 7.94108 9.15918 9.64941C7.45085 11.3577 6.59668 13.4202 6.59668 15.8369C6.59668 18.2536 7.45085 20.3161 9.15918 22.0244C10.8675 23.7327 12.93 24.5869 15.3467 24.5869ZM15.3467 20.8369C13.9717 20.8369 12.7946 20.3473 11.8154 19.3682C10.8363 18.389 10.3467 17.2119 10.3467 15.8369C10.3467 14.4619 10.8363 13.2848 11.8154 12.3057C12.7946 11.3265 13.9717 10.8369 15.3467 10.8369C16.7217 10.8369 17.8988 11.3265 18.8779 12.3057C19.8571 13.2848 20.3467 14.4619 20.3467 15.8369C20.3467 17.2119 19.8571 18.389 18.8779 19.3682C17.8988 20.3473 16.7217 20.8369 15.3467 20.8369ZM15.3467 18.3369C16.0342 18.3369 16.6227 18.0921 17.1123 17.6025C17.6019 17.113 17.8467 16.5244 17.8467 15.8369C17.8467 15.1494 17.6019 14.5609 17.1123 14.0713C16.6227 13.5817 16.0342 13.3369 15.3467 13.3369C14.6592 13.3369 14.0706 13.5817 13.5811 14.0713C13.0915 14.5609 12.8467 15.1494 12.8467 15.8369C12.8467 16.5244 13.0915 17.113 13.5811 17.6025C14.0706 18.0921 14.6592 18.3369 15.3467 18.3369Z" fill="#1D34FE"/>\n' +
				'  </g>\n' +
				'</svg>';
			locationButton.onclick = () => {
				this.showUserLocation(true);
			};

			return container;
		};

		customButtons.addTo(this.map);
	}

	initializeButton() {
		const button = document.getElementById('map-toggle-button');
		if (button) {
			button.addEventListener('click', e => this.toggleMap());
		} else {
			console.error('Tlačítko pro přepínání mapy není k dispozici.');
		}
	}

	toggleMap() {
		const mapElement = document.getElementById(this.mapElementId);
		const button = document.getElementById('map-toggle-button');
		if (mapElement) {
			mapElement.classList.toggle('open');

			if (mapElement.classList.contains('open')) {
				button.classList.add('open');
			} else {
				button.classList.remove('open');
			}
			setTimeout(() => {
				this.map.invalidateSize();
			}, 300);
		} else {
			console.error('Element mapy nebyl nalezen.');
		}
	}

	addMarkers(items) {
		this.markersCluster.clearLayers();

		items.forEach(item => {
			let marker = L.marker([item.lat, item.lng], {
				icon: this.pinIcon,
			});
			marker.bindPopup(this.createPopup(item));
			this.markersCluster.addLayer(marker);
		});
		this.map.invalidateSize();
	}

	createPopup(item) {
		if (item.type === 'hotel') {
			return `<span class='marker-title'>${item.name}</span><p>${item.content}</p><a class="link arrow" href='${item.link}' target="_blank" rel="noopener">web</a>`;
		}
		return `<span class='marker-title'>${item.name}</span><p>${item.content}</p><a class="link arrow" href='${item.link}'>prohlédnout</a>`;
	}

	showUserLocation(handle = false) {
		this.getLocation().then(location => {
			console.log(location[2]);
			this.setUserPointer(location, handle);
			if (parseFloat(location[2]) > 30) {
				setTimeout(() => {
					this.showUserLocation();
				}, 5000);
			}
		});
	}

	setUserPointer(location, handle) {
		if (handle) {
			this.map.setView([location[0], location[1]], 16);
		}

		if (parseFloat(location[2]) <= 30) {
			if (this.accuracyCircle) {
				// Update the accuracy circle's position and radius
				this.accuracyCircle.setLatLng([location[0], location[1]]);
				this.accuracyCircle.setRadius(location[2]);
			} else {
				// Create a new accuracy circle if it doesn't exist
				this.accuracyCircle = L.circle([location[0], location[1]], {
					color: '#1d34fe',
					fillColor: '#1d34fe',
					fillOpacity: 0.2,
					radius: location[2],
				}).addTo(this.map);
			}

			if (this.userMarker) {
				this.map.removeLayer(this.userMarker);
			}

			this.userMarker = L.marker([location[0], location[1]], {
				icon: this.pinIconBlue,
			}).addTo(this.map);
			this.userMarker.bindPopup(
				"<span class='marker-title'>Vaše poloha</span>",
			);
		} else {
			if (this.userMarker) {
				this.map.removeLayer(this.userMarker);
				this.userMarker = null;
			}

			if (this.accuracyCircle) {
				// Update the accuracy circle's position and radius
				this.accuracyCircle.setLatLng([location[0], location[1]]);
				this.accuracyCircle.setRadius(location[2]);
			} else {
				// Create a new accuracy circle if it doesn't exist
				this.accuracyCircle = L.circle([location[0], location[1]], {
					color: '#1d34fe',
					fillColor: '#1d34fe',
					fillOpacity: 0.2,
					radius: location[2],
				}).addTo(this.map);
			}
		}
	}

	getLocation() {
		return new Promise((resolve, reject) => {
			const storedLatitude = parseFloat(localStorage.getItem('latitude'));
			const storedLongitude = parseFloat(
				localStorage.getItem('longitude'),
			);
			const storedAccuracy = parseFloat(localStorage.getItem('accuracy'));
			const storedTimestamp = localStorage.getItem('locationTimestamp');

			const EXPIRY_DURATION = 60 * 60 * 1000; // 5 minut

			console.log(storedAccuracy);
			if (
				storedLatitude &&
				storedLongitude &&
				storedTimestamp &&
				Date.now() - storedTimestamp < EXPIRY_DURATION &&
				parseFloat(storedAccuracy) <= 30
			) {
				console.log('Using stored location');
				resolve([storedLatitude, storedLongitude, storedAccuracy]);
				return;
			}

			if (!navigator.geolocation) {
				alert('Geolokace není podporována vaším prohlížečem');
				reject('Geolocation not supported');
				return;
			}

			navigator.geolocation.watchPosition(
				position => {
					const { latitude, longitude, accuracy } = position.coords;
					localStorage.setItem('latitude', latitude.toString());
					localStorage.setItem('longitude', longitude.toString());
					localStorage.setItem('accuracy', accuracy.toString());
					localStorage.setItem(
						'locationTimestamp',
						Date.now().toString(),
					);

					resolve([latitude, longitude, accuracy]);
				},
				error => {
					console.log(error);
					reject(error);
				},
				{
					enableHighAccuracy: true,
					timeout: 10000,
					maximumAge: 5 * 60 * 1000, // 5 minutes
				},
			);
		});
	}
}

export default MapController;
